const LSK_USER = 'user';

/**
 * Returns the current user
 * @category Core
 * @subcategory User
 * @returns User
 */
export function getUser(): User {
  const user = sessionStorage.getItem(LSK_USER);

  //@ts-ignore
  return user ? JSON.parse(user) : null;
}

/**
 * Returns the permissions list by numeric code
 * @category Core
 * @subcategory User
 * @returns number[]
 */
export function getPerms(): string[] {
  // Get user info and perms
  const user = getUser();
  const perms = user ? user.perms : [];
  return perms;
}
/**
 * Set user
 * @category Core
 * @subcategory User
 * @param  {User} user
 */
export function setUser(user: User) {
  sessionStorage.setItem(LSK_USER, JSON.stringify(user));
}

/**
 * Makes the logout logic
 * @category Core
 * @subcategory User
 */
export function logOut() {
  sessionStorage.removeItem(LSK_USER);
}

/**
 * User interface
 * @category Interface
 * @param {number[]} permissions current user's permissions
 * @param {name} name the user's name
 * @param {string} token the user's token
 */
export interface User {
  sub: string;
  perms: string[];
  id: string;
  type: string;
  token: string;
  role: string;
}
